module.exports = __webpack_public_path__ + "static/member01-a1b43684cf530793a7a998d3c392d1fa.jpg";